import { render, staticRenderFns } from "./tablero.vue?vue&type=template&id=2da56197&scoped=true&"
import script from "./tablero.vue?vue&type=script&lang=js&"
export * from "./tablero.vue?vue&type=script&lang=js&"
import style0 from "./tablero.vue?vue&type=style&index=0&id=2da56197&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da56197",
  null
  
)

export default component.exports